import { useField, useFormikContext } from 'formik';

import { Input, InputProps } from './Input';

export interface FormikInputProps extends InputProps {
    name: string;
}

export const FormikInput = ({ name, caption, ...rest }: FormikInputProps) => {
    const [field, meta, helpers] = useField(name);
    const { validateOnChange } = useFormikContext();

    return (
        <Input
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error && typeof meta.error === 'string' ? meta.error : caption}
            {...rest}
            {...field}
            onChange={(event) => {
                field.onChange(event);
                if (!validateOnChange && meta.error) {
                    helpers.setError(undefined);
                }
            }}
        />
    );
};
